import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { EVALUATION } from '@/data/content';
import { FileText, TrendingUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Evaluation() {
  return (
    <div>
      <SEO
        title="Independent Program Evaluation"
        description="A 78-question pre and post evaluation by the Mercyhurst College Civic Institute measured student attitude changes after the Drug and Alcohol Awareness program."
        path="/evaluation"
      />
      <PageHero
        title="Independent Program Evaluation"
        subtitle="Mercyhurst College Civic Institute conducted a 78-question pre and post evaluation of the program."
        image="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1920&q=80"
        crumbs={['Evaluation']}
      />
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-4 mb-12">
          {EVALUATION.stats.map((s) => (
            <div key={s.label} className="p-6 bg-white border-l-4 border-amber-400 rounded-md shadow-sm">
              <div className="font-serif text-4xl font-bold text-[#0b2545]">{s.value}</div>
              <div className="text-xs uppercase tracking-widest text-slate-500 mt-2">{s.label}</div>
            </div>
          ))}
        </div>

        <p className="text-lg text-slate-800 font-serif italic leading-relaxed mb-8">
          {EVALUATION.intro}
        </p>

        <div className="space-y-5 mb-10">
          {EVALUATION.paragraphs.map((p, i) => (
            <p key={i} className="text-slate-700 leading-[1.85] text-[15.5px]">{p}</p>
          ))}
        </div>

        <div className="p-8 bg-gradient-to-br from-amber-50 to-slate-50 rounded-lg border border-amber-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="h-14 w-14 rounded-full bg-amber-500 text-white flex items-center justify-center flex-shrink-0">
              <TrendingUp className="h-7 w-7" />
            </div>
            <div className="flex-1">
              <h3 className="font-serif text-xl font-bold text-[#0b2545] mb-1">Read the Study Findings</h3>
              <p className="text-sm text-slate-600">A copy of the Civic Institute evaluation report is available to view online.</p>
            </div>
            <Button asChild className="bg-[#0b2545] hover:bg-[#123a6b] text-white">
              <a
                href="https://acrobat.adobe.com/id/urn:aaid:sc:US:3229abc3-8189-497b-a996-e80308840d60"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FileText className="mr-2 h-4 w-4" /> View Survey PDF
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
